export default function Logo() {
    return <a href="/"><img src="/img/l33tstudio_logo_white.png" id="logo" alt="Logo" /></a>
}
